<template>
  <VApp>
    <notifications-manager />
    <RouterView />
    <ConsentBanner />
  </VApp>
</template>

<script setup lang="ts">
/**
 * @component App
 * @description WHAT: Concise summary of what this component does. WHY: Business or UX reason. WHEN: When it runs or reacts. HOW: Key techniques (state, props, emits).
 */
import { onMounted } from 'vue'
import { useAuthStore } from './stores/authStore'
import NotificationsManager from './components/NotificationsManager.vue'
import ConsentBanner from './components/ConsentBanner.vue'

const authStore = useAuthStore()

onMounted(async () => {
  // On tente de récupérer le jeton public au chargement de l'application.
  // La logique interne de `ensurePublicSessionToken` gère les cas
  // où l'utilisateur est déjà connecté ou qu'un jeton existe déjà.
  await authStore.ensurePublicSessionToken();
  // Laisser le navigateur finaliser l'écriture du cookie d'auth (cas OAuth)
  await new Promise((resolve) => setTimeout(resolve, 50));

  // Le chargement de l'utilisateur appartient à la garde globale du routeur
  // (`router/index.ts`), qui appelle `initializeUser()` pour toute route non
  // publique dont l'utilisateur n'est pas encore chargé.
  //
  // Il y avait ici un bloc conditionné à `localStorage.getItem('token')`.
  // L'application est en authentification par cookie — « plus de tokens
  // locaux » (`services/auth.ts`) — et rien n'écrit jamais cette clé : le
  // bloc ne s'exécutait donc jamais.
})
</script>

<style>
.app {
  width: 100%;
  height: 100%;
  font-family: Arial, sans-serif;
}
</style>
